import SignupForm from "../../components/signupform/SignupForm";

const Signup = () => {
  return <SignupForm />;
};

export default Signup;
